export const FONT_FAMILY = "'Source Sans Pro', sans-serif";

export const FONT_FAMILY_ROBOTO = "'Roboto', sans-serif";

export const FONT_FAMILY_SECONDARY = "'Open Sans Variable', sans-serif";

export const FONT_FAMILY_ROBOTO_MONO = "'Roboto Mono Variable', monospace;";

export const FONT_FAMILY_DEJAVU_MONO = "'DejaVu Mono', monospace";

export const FONT_FAMILY_SOURCE_CODE_PRO = "'Source Code Pro Variable', monospace";
